import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";
import { sortOptions } from "../../../utils/sortOptions";

export const selectSortButton = createSelector(
  [(store: RootState) => store.documentsSignerList.sort],
  (sort) => {
    const result = sortOptions.filter(({ value }) => value !== sort);
    return result;
  }
);
